import { memoize } from "lodash";
import { TOption, TPermissions } from "../../Types";
import i18n from "../../constants/i18n";
import { IComputedValue, computed } from "mobx";

class RoutingStore {
  USER_OPTIONS: IComputedValue<TOption[]> = computed(() => {
    const userOptionsArray: TOption[] = [
      {
        title: i18n.get("ADVANCED"),
        link: "/users/advanced",
        name: TPermissions.User,
        pageName: "USER_ADVANCED",
        pageSubName: "USER_ADVANCED",
        visibility: true
      },
      {
        title: i18n.get("EVENTS"),
        link: "/users/events",
        name: TPermissions.User,
        pageName: "USER_EVENTS",
        pageSubName: "USER_EVENTS",
        visibility: true
      },
      {
        title: i18n.get("MESSAGES"),
        link: "/users/messages",
        name: TPermissions.User,
        pageName: "USER_MESSAGES",
        pageSubName: "USER_MESSAGES",
        visibility: true
      },
      {
        title: i18n.get("PAYMENTS"),
        link: "/users/payments",
        name: TPermissions.User,
        pageName: "USER_PAYMENTS",
        pageSubName: "USER_PAYMENTS",
        visibility: true
      }
    ];
    return userOptionsArray;
  });
}

const getRoutingStore = memoize(
  () => new RoutingStore(),
  () => 1
);
export default getRoutingStore;
